import { render, staticRenderFns } from "./FeedFrom.vue?vue&type=template&id=1fe097c3&scoped=true"
import script from "./FeedFrom.vue?vue&type=script&lang=js"
export * from "./FeedFrom.vue?vue&type=script&lang=js"
import style0 from "./FeedFrom.vue?vue&type=style&index=0&id=1fe097c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe097c3",
  null
  
)

export default component.exports